/**
 * Presentation Document ID Manager (PowerPoint host).
 */

import { OfficeDocumentIdManager } from "@carousel-office/shared";
import { documentId as normalizeDocumentId } from "../utils/idNormalizer";

const manager = new OfficeDocumentIdManager({
  host: "powerpoint",
  namespace: "http://schemas.slideknowledgegraph.com/carouseldeck",
  rootTag: "CarouselDeck",
  idTag: "documentId",
  normalizeId: normalizeDocumentId,
  label: "documentId",
});

export async function getOrCreatedocumentId(): Promise<string> {
  return manager.getOrCreateDocumentId();
}

export async function getdocumentId(): Promise<string | null> {
  return manager.getDocumentId();
}

